import MAIN from './main';
import IMAGE_LOADER from './image-loader';
import IMAGE from './image';
import GALLERY_CAROUSEL from './gallery-carousel';
import PICTURE from './picture';
import LIGHTBOX from './lightbox';
import { constants } from '../../../../../../utils/octopus';

const { OWNERSHIPS } = constants;

const CorePlugin = {
  definitions: {
    ...MAIN,
    ...IMAGE_LOADER,
    ...IMAGE,
    ...GALLERY_CAROUSEL,
    ...PICTURE,
    ...LIGHTBOX,
  },
  ownership: OWNERSHIPS.VPP,
};

export default CorePlugin;
